export const convertCurrentDateToLocalDate = () => {
    const currentDate = new Date();
    return convertToLocalDate(currentDate);
}

export const convertPreviousDateToLocalDate = () => {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() - 1);
    return convertToLocalDate(currentDate);
}

const convertToLocalDate = (date: Date) => {
    const day = (date.getDate() > 9) ? date.getDate() : ('0' + (date.getDate()));
    const month = (date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1));
    const year = date.getFullYear()
    // ISO 8601 Date : pattern must match "yyyy-MM-dd"
    return year + '-' + month + '-' + day;
}

//TODO: Change the cut-off time to 9 A.M. after UAT
export const SAVE_TRADE_CUTOFF_TIME = 8;
